import styles from './ResultModal.module.scss';
import { ucFirst } from '../Utils/caseconverters';
import classNames from 'classnames';

function ResultModal({
  colorTheme,
  answers,
  screens,
  show,
  userName,
  questions,
  onClose
}) {
  const screensToExclude = ["ScreenStart", "ScreenResult", "ScreenName", "ScreenInfo"];
  const filteredScreens = screens && screens.filter(screen => !screensToExclude.includes(screen.component));

  const getCorrects = (index) => {
    if (questions.length > 0) {
      const currentQuestion = questions[index];
      if (currentQuestion.hasOwnProperty('options')) {
        return currentQuestion.options.filter(option => option.isCorrect);
      } else if (currentQuestion.hasOwnProperty('correctMax') && currentQuestion.hasOwnProperty('correctMin')) {
        const { correctMax, correctMin } = currentQuestion;
        if (correctMax > correctMin) {
          return [{ text: `Mellan ${correctMin} och ${correctMax}` }];
        } else {
          return [{ text: `${correctMin}` }];
        }
      }
    }
    return [];
  };

  return (
    <div
      className={classNames(
        styles["ResultModal"],
        styles[`ResultModal--${ucFirst(colorTheme)}`], {
        [styles["ResultModal--Show"]]: show,
      })}
    >
      <div className={styles["ResultModal__Result"]}>
        <div className={styles["ResultModal__TitleRow"]}>
          <h2 className={styles["ResultModal__Title"]}>Summering av dina svar</h2>
          <button onClick={onClose} aria-label="Stäng" className={styles["ResultModal__Close"]}>
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <ul className={styles["ResultModal__ResultList"]}>
          {filteredScreens && answers.length > 0 && (
            filteredScreens.map((screen, index) => {
              const answer = answers[index];
              const corrects = getCorrects(index);

              return (
                <li key={index} className={styles["ResultModal__ResultItem"]}>
                  <div className={styles["ResultModal__Question"]}>
                    <span className={styles["ResultModal__QuestionCount"]}>{index + 1}.</span>
                    <div>
                      <h3 className={styles["ResultModal__QuestionTitle"]}>{screen.title.replaceAll("%NAME%", userName)}</h3>
                      {answer && (
                        <>
                          <div className={styles["ResultModal__AnswerWrapper"]}>
                            <span className={styles["ResultModal__Answer"]}>Ditt svar: </span>{answer.isImageChoice ? <ImagesAnswer questions={questions} {...answer} /> : <TextAnswer {...answer} />}
                          </div>
                          {corrects && corrects.length > 0 && (
                            <div className={styles["ResultModal__CorrectsWrapper"]}>
                              <span className={styles["ResultModal__Answer"]}>Rätt svar: </span>{answer.isImageChoice ? <ImagesCorrects corrects={corrects} /> : <TextCorrects corrects={corrects} />}
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </li>
              )
            })
          )}
        </ul>
      </div>
    </div>
  );
}

const ImagesAnswer = ({ answers }) => {
  return (
    <div className={styles["ResultModal__Answers"]}>
      {answers.map((image, index) => (
        <img alt="Ditt svar" src={image} key={index} className={styles["ResultModal__AnswerImage"]} />
      ))}
    </div>
  )
}

const ImagesCorrects = ({ corrects }) => {
  return (
    <div className={styles["ResultModal__Answers"]}>
      {corrects.map((item, index) => (
        <img alt="Rätt svar" src={item.image.src} key={index} className={styles["ResultModal__AnswerImage"]} />
      ))}
    </div>
  )
}

const TextAnswer = ({ answers }) => {
  const answer = answers.join(', ');

  return (
    <div className={styles["ResultModal__Answers"]}>
      <p className={styles["ResultModal__AnswerText"]}>{answer}</p>
    </div>
  )
}

const TextCorrects = ({ corrects }) => {
  const correctAnswers = corrects.map(item => item.text).join(', ');

  return (
    <div className={styles["ResultModal__Answers"]}>
      <p className={styles["ResultModal__AnswerText"]}>{correctAnswers}</p>
    </div>
  )
}

ResultModal.defaultProps = {
  colorTheme: "",
  answers: [],
};

export default ResultModal;
